<script setup lang="ts">
import type { FormMeta, GenericObject } from 'vee-validate';
import type { PropType } from 'vue';

import { defineProps, withDefaults } from 'vue';

import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import type { Locales } from '@/services/types/api.types';
import type { LocaleValidation } from '@/composables/language-validation-errors';

const editLocale = defineModel<Locales>('editLocale', {
  type: String as PropType<Locales>,
});

withDefaults(
  defineProps<{
    onCancel: () => void;
    onSubmit: () => void;
    languageErrors: LocaleValidation;
    meta: FormMeta<GenericObject>;
    showLanguageSwitcher?: boolean;
    languageEnabled: Locales[];
  }>(),
  { showLanguageSwitcher: true },
);
</script>

<template>
  <div class="row q-pb-md">
    <language-switcher
      v-if="showLanguageSwitcher && languageEnabled.length > 1"
      v-model="editLocale"
      :has-validation-errors="languageErrors"
      :language-enabled="languageEnabled"
    />
    <q-space />
    <transition>
      <div v-if="meta.dirty" key="form-buttons">
        <q-btn :label="$t('global.cancel')" flat :disabled="!meta.dirty" class="q-mr-md" @click="onCancel" />
        <q-btn color="accent" :label="$t('global.save')" :disabled="!meta.dirty || !meta.valid" @click="onSubmit" />
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
